export const getFields = () => {
  const zoneFields = [
    {
      type: "text",
      displayName: "Nombre",
      name: "name",
      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "longText",
      displayName: "Descipción",
      name: "description",
      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },
  ];
  const neighborhoodFields = [
    {
      type: "select",
      displayName: "Ciudad",
      name: "locality",
      searchPath: "localities",
      primaryKey: "composite_field",

      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "text",
      displayName: "Nombre",
      name: "name",
      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "longText",
      displayName: "Descipción",
      name: "description",
      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },
  ];
  const addressFields = [
    {
      type: "text",
      displayName: "Calle",
      name: "street",
      description: null,
      size: 6,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "text",
      displayName: "Num.",
      name: "number",
      description: null,
      size: 3,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "text",
      displayName: "Código postal",
      name: "postal_code",
      description: null,
      size: 3,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "longText",
      displayName: "Observación",
      name: "observation",
      placeholder: "Ej; piso, manzana, bloque...",
      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "select",
      displayName: "Barrio",
      name: "neighborhood",
      searchPath: "neighborhoods",
      primaryKey: "composite_field",

      formTitle: "Barrio",
      formFields: neighborhoodFields,

      description: null,
      size: 6,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "select",
      displayName: "Zona",
      name: "zone",
      searchPath: "zones",
      primaryKey: "name",

      description: null,
      formTitle: "Zona",
      formFields: zoneFields,
      size: 6,
      editable: true,
      editableIf: null,
      validations: {},
    },
    {
      type: "select",
      displayName: "Ciudad",
      name: "locality",
      searchPath: "localities",
      primaryKey: "composite_field",

      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },

    {
      type: "coordinates",
      displayName: "Coordenadas",
      name: "coordinates",
      description: null,
      size: 12,
      editable: true,
      editableIf: null,
      validations: {},
    },
  ];
  const data: any = {
    customer: [
      {
        type: "text",
        displayName: "Nombre",
        name: "name",
        description: null,
        size: 12,
        editable: true,
        editableIf: null,
        validations: {},
      },
      {
        type: "email",
        displayName: "Email",
        name: "email",
        description: null,
        size: 6,
        editable: null,
        editableIf: null,
        validations: {},
      },
      {
        type: "text",
        displayName: "Whatsapp",
        name: "whatsapp_number",
        description: null,
        size: 6,
        editable: null,
        editableIf: null,
        validations: {},
      },
      {
        type: "integer",
        displayName: "DNI",
        name: "personal_id",
        size: 6,
        description: "Solo números (sin puntos)",
        editable: null,
        editableIf: null,
        validations: {},
      },
      {
        type: "integer",
        displayName: "CUIT",
        name: "tax_id",
        description: "Solo números (sin puntos ni guiones)",
        size: 6,
        editable: null,
        editableIf: null,
        validations: {},
      },
      {
        type: "radio",
        displayName: "Condición frente al IVA",
        name: "vat_condition",
        description: null,
        options: [
          {
            name: "Consumidor final",
            displayName: "Consumidor final",
          },
          {
            name: "Responsable monotributo",
            displayName: "Responsable monotributo",
          },
          {
            name: "Responsable inscripto",
            displayName: "Responsable inscripto",
          },
          {
            name: "Exento",
            displayName: "Exento",
          },
        ],
        size: 12,
        showIf: null,
        editable: null,
        editableIf: null,
        validations: {},
      },
      {
        type: "tags",
        displayName: "Etiquetas",
        name: "tags",
        description: null,
        size: 12,
        tagGroup: {
          id: 3,
        },
        editable: true,
        editableIf: null,
        validations: {},
      },
      {
        type: "select",
        displayName: "Domicilio",
        name: "address",
        searchPath: "addresses",
        primaryKey: "composite_field",
        //secondaryKey: "display_identifiers",
        formFields: addressFields,
        formTitle: "Domicilio",
        description: null,
        size: 12,
        editable: true,
        editableIf: null,
        validations: {},
      },
      {
        type: "longText",
        displayName: "Descripción",
        name: "description",
        description: null,
        size: 12,
        editable: null,
        editableIf: null,
        validations: {},
      },
    ],
    supplier: [
      {
        type: "text",
        displayName: "Nombre",
        name: "name",
        description: null,
        size: 6,
        editable: null,
        editableIf: null,
        validations: {},
      },
      {
        type: "text",
        displayName: "C.U.I.T",
        name: "tin",
        description: null,
        size: 6,
        editable: null,
        editableIf: null,
        validations: {},
      },
    ],

    withholding: [
      {
        type: "text",
        displayName: "Nombre",
        name: "name",
        description: null,
        size: 6,
        editable: null,
        editableIf: null,
        validations: {},
      },
      {
        type: "decimal",
        displayName: "Alícuota",
        name: "rate",
        description: null,
        size: 6,
        editable: null,
        editableIf: null,
        append: "%",
        validations: {},
      },
    ],
  };

  return data;
};
